import { UPDATE_USER_PROFILE} from '../actions/index';

export default function userProfile(state = {}, action) {
    switch (action.type){
        case UPDATE_USER_PROFILE:
            localStorage.setItem('userProfile', JSON.stringify(action.userProfile));
            return Object.assign({}, state, action.userProfile)
        default:
            return state;
    }
}
